import { useQuery } from "@tanstack/react-query";

import useEmailStore from "@store/useEmailStore";
import useSystemStore from "@store/useSystemStore";
import emailService from "@services/email.service";
import { THREAD_ATTACHMENTS_QUERY_KEY, QUERY_CACHE_DEFAULT_EXPIRATION_MS } from "@config/query";

export function useGetThreadAttachments(enabled: boolean = true) {
  const { threadId } = useEmailStore();
  const { isAppActive } = useSystemStore();

  return useQuery({
    enabled: enabled && isAppActive && !!threadId,
    queryKey: [THREAD_ATTACHMENTS_QUERY_KEY, threadId],
    queryFn: async () => {
      return await emailService.getThreadAttachments(threadId);
    },
    staleTime: QUERY_CACHE_DEFAULT_EXPIRATION_MS,
    retry: false,
  });
}
